import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import {LoadingButton} from "@mui/lab";
import {
  CreateCustomerInput,
  CreateOrderInput,
  Customer,
  OrderStatus,
  OrderType,
  PaymentStatus,
  UpdateCustomerInput,
} from "../API";

import { OrderRepository } from "../DAL/repositories/OrderRepository";
import {
  CustomerInfo,
  ImageSelecter,
  OrderInfo,
} from "../components/StepperContent";
import {
  ResourceOperation,
  useApplicationStore,
} from "../context/ApplicationStoreContext";
import { useNavigate } from "react-router-dom";
import { CustomerConfirmCard, OrderConfirmCard } from "../components/Confirm";
import Stack from "@mui/material/Stack";
import { CustomerRepository } from "../DAL/repositories/CustomerRepository";
import { PaymentRepository } from "../DAL/repositories/PaymentRepository";
import { useEffect, useState } from "react";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { uploadImage2S3 } from "../util/Storage";

const step_num = 4;

export const NoveltyCookieOrderPage: React.FC = () => {
  const [activeStep, setActiveStep] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const { state, dispatch } = useApplicationStore();
  const { user } = useAuthenticator((context) => [context.user]);

  const handleNext = () => {
    //setActiveStep((prevActiveStep) => prevActiveStep + 1);
    dispatch({ type: ResourceOperation.ADD_INDEX });
    console.log("store@next:", state);
  };

  const handleBack = () => {
    //setActiveStep((prevActiveStep) => prevActiveStep - 1);
    dispatch({ type: ResourceOperation.SUB_INDEX });
  };

  const handleReset = () => {
    setActiveStep(0);
  };
  const navigate = useNavigate();

  const createPaymentIntent = () => {
    setIsLoading(true)
    uploadImage2S3(state.uploadImage!)
      .then(() =>
        CustomerRepository()
          .update(state.customer as UpdateCustomerInput)
          .then((customer) =>
            OrderRepository().create(outputCreateOrderInput(customer))
          )
      )
      .then((order) => PaymentRepository().create(order))
      .then(async (result) => {
        if (!state.customer?.stripeCustomerId) {
          const updateCustomer = state.customer as UpdateCustomerInput;
          updateCustomer.stripeCustomerId = result.stripe_customer_id;
          await CustomerRepository().update(updateCustomer);
        }
        dispatch({
          type: ResourceOperation.CREATE_PAYMENT_INFO,
          payload: result,
        });
        navigate("/confirm");
      });
    /*
     { 
       stripe_customer_id: "cus_LabgD43Ugefy7t", 
       payment_intent_id: "pi_3KtQTCG3mczfCHwA0uUhMlFK", 
       clientSecret: "pi_3KtQTCG3mczfCHwA0uUhMlFK_secret_ecP1ONwGWuLGLULxDxZsSmDb3"
      }
    */
  };

  const outputCreateOrderInput = (customer: Customer) => {

    return {
      name: "ノベルティクッキー",
      amount: state.orderInfoForm?.amount!,
      subTotal: state.orderInfoForm?.total!,
      shippingFee: state.shippingFee,
      total: state.orderInfoForm?.total! + state.shippingFee,
      image: state.uploadImage?.name!,
      type: OrderType.COOKIE,
      status: OrderStatus.NEW,
      paymentStatus: PaymentStatus.PENDING,
      destination: customer.address[customer.destinationIndex || 0]!,
      customerId: customer.id,
    } as CreateOrderInput;
  };

  useEffect(() => {
    //localStorage.removeItem("redirect_to")
  
    CustomerRepository()
      .get(user.username!)
      .then((result) => {
        dispatch({ type: ResourceOperation.GET_CUSTOMER, payload: result });
      })
      .catch(async (err) => {
        const newCustomer: CreateCustomerInput = {
          id: user.username!,
          lineId: "",
          name: "",
          email: "",
          phone: "",
          address: [],
        };
        await CustomerRepository()
          .create(newCustomer)
          .then((result) => {
            dispatch({
              type: ResourceOperation.CREATE_CUSTOMER,
              payload: result,
            });
          });
      });
  }, []);

  return (
    <Box px={1.5} py={1}>
      <Stepper activeStep={state.stepperIndex} orientation="vertical">
        <Step key="1">
          <StepLabel
            optional={
              <Typography variant="caption">
                画像を選択してください。
              </Typography>
            }
          >
            画像のアップロード
          </StepLabel>
          <StepContent>
            <ImageSelecter />
          </StepContent>
        </Step>
        <Step key="2">
          <StepLabel
            optional={
              <Typography variant="caption">注文する個数の入力</Typography>
            }
          >
            注文情報
          </StepLabel>
          <StepContent>
            <Box>
              <OrderInfo />
            </Box>
          </StepContent>
        </Step>
        <Step key="3">
          <StepLabel
            optional={
              <Typography variant="caption">
                お客さま情報とお届先情報の入力
              </Typography>
            }
          >
            お客さま情報
          </StepLabel>
          <StepContent>
            <CustomerInfo />
          </StepContent>
        </Step>

        <Step key="4">
          <StepLabel optional={<Typography variant="caption">確認</Typography>}>
            注文情報の確認
          </StepLabel>
          <StepContent>
            <Stack spacing={1.5}>
              <OrderConfirmCard />
              <CustomerConfirmCard />
              <Box sx={{ mb: 2 }}>
                <div>
                  <LoadingButton 
                    variant="contained"
                    loading={isLoading}
                    onClick={() => createPaymentIntent()}
                    sx={{ mt: 1, mr: 1 }}
                  >
                    決済に進む
                  </LoadingButton>
                  <Button onClick={handleBack} sx={{ mt: 1, mr: 1 }}>
                    戻る
                  </Button>
                </div>
              </Box>
            </Stack>
          </StepContent>
        </Step>
      </Stepper>
    </Box>
  );
};
